import { render, staticRenderFns } from "./TextNode.vue?vue&type=template&id=64880130"
import script from "./TextNode.vue?vue&type=script&lang=js"
export * from "./TextNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports